import { makeAutoObservable, runInAction } from 'mobx'
import { memberMobx } from '@mobxStore'
import { productMobx, restaurantCenter, RESTAURANT_EVENT } from 'restaurant'
import ProductAPI from 'api/product.api'
import { uniqBy, debounce } from '@dt/fe-utils/dist/lodash'

interface IBoughtProduct {
  /** 餐品no */
  no: string;
  /** 数量 */
  cnt: number;
}

class BoughtProduct {
  constructor () {
    makeAutoObservable(this)

    const _init = debounce(() => {
      this.init()
    }, 500)

    // 监听菜单、会员登录
    restaurantCenter.on(RESTAURANT_EVENT.CONFIG_MEMBER_CHANGED, () => {
      memberMobx.isLogin && _init()
    })
  }

  boughtProductList: IBoughtProduct[] = []

  get boughtViewProduct (): IViewProduct[] {
    const list: IViewProduct[] = []
    this.boughtProductList.map(v => {
      const viewProduct = productMobx.noToViewProductMap[v.no]
      if (viewProduct) {
        list.push(viewProduct)
      }
    })
    return list.filter(item => item.isNotSingleInCombo && !item.isOpenPrice && item.isShowInMenu && !item.disable && item.saleCnt !== 0).splice(0, 2)
  }

  init () {
    ProductAPI.getBoughtProduct().then((res: IBoughtProduct[]) => {
      if (res.length) {
        runInAction(() => {
          this.boughtProductList = uniqBy(res.sort((a, b) => b.cnt - a.cnt), 'no')
        })
      }
    })
  }
}

export default new BoughtProduct()
